/**
 * Gets a Text and a Priority and logs it into a source
 * @param {String} info 
 * @param {*} errLvl 
 */
function logError(info, errLvl){
    console.log("Error occured! --> "+info+" p: "+errLvl);
}

export default logError;